<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>代理模式设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formBody">
      <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="belongCount" label="等级" width="150">
      </el-table-column>
      <el-table-column align="center" prop="per" label="收益率" width="150">
        <template slot-scope="scope">
            <div v-html="scope.row.per"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="needAmount" label="需要金额" width="150">
        <template slot-scope="scope">
            <div v-html="scope.row.needAmount"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="50" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="editUser(scope.$index, scope.row)">修改比例</el-button>
        </template>
      </el-table-column>
    </el-table>

      <el-dialog title="修改比例" :visible.sync="editTwoFormVisible" width="30%" @click='closeDialog()'>
        <el-form label-width="80px">
          <el-form-item label="收益率" prop="userName">
            <el-input size="small" v-model="newShowData.per" auto-complete="off" placeholder="请输入收益率"></el-input>
          </el-form-item>
          <el-form-item label="需要金额" prop="userName">
            <el-input size="small" v-model="newShowData.needAmount" auto-complete="off" placeholder="请输入需要金额"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click='closeDialog()'>取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFormUnit()">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { setVIP2Data } from '../../api/userMG'
export default {
  data() {
    return {
      userData: [],
      editTwoFormVisible: false,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      newShowData:[]
    }
  },
  // 注册组件
  components: {
    
  },
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.loading = true
      setVIP2Data().then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data
        }
      })
      .catch(err => {
        this.editFormVisible = false
        this.loading = false
        this.$message.error('请稍后再试！')
      })
    },
    //显示编辑界面
    editUser: function(index, row) {
      console.log(row)
      this.newShowData = row;
      this.editTwoFormVisible = true;
    },
    closeDialog() {
      this.editTwoFormVisible = false
    },
  }
}
</script>

<style scoped>
.formBody{
  margin-top: 40px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/adminSet/paySet.vue